import React from 'react';
import { FilterList } from '@mui/icons-material';

import { Button } from '../../../../components/core/Button/Button';

interface Props {
  filtersCount: number;
  onClick: () => void;
  disabled?: boolean;
}

export const FiltersButton = ({ onClick, filtersCount, disabled = false }: Props) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      startIcon={<FilterList />}
      theme="secondary"
      text={`Filters${filtersCount > 0 ? ` (${filtersCount})` : ''}`}
      sx={{
        width: { xs: '100%', sm: 150 },
        whiteSpace: 'nowrap',
        ...(filtersCount > 0 && {
          backgroundColor: 'grey.200',
          borderColor: 'primary.dark',
          '&:hover': {
            backgroundColor: 'grey.100',
          },
        }),
      }}
    />
  );
};
